<template>
      <thead>
        <tr>
          <th scope="col">
            <span class='search-result-header'>Project ID</span>
            <a @click="changeSort('id')">
              <font-awesome-icon
              :class="getSortClass('id')"
              :icon="getSortIcon('id')"/>
            </a>
          </th>
          <th scope="col">
            <span class='search-result-header'>Project Name</span>
            <a @click="changeSort('name')">
              <font-awesome-icon
              :class="getSortClass('name')"
              :icon="getSortIcon('name')"/>
            </a>
          </th>
          <th scope="col">
            <span class='search-result-header'>Status</span>
            <a @click="changeSort('status')">
              <font-awesome-icon
              :class="getSortClass('status')"
              :icon="getSortIcon('status')"/>
            </a>
          </th>
          <th scope="col">
            <span class='search-result-header'>Total Acres</span>
            <a @click="changeSort('acres')">
              <font-awesome-icon
              :class="getSortClass('acres')"
              :icon="getSortIcon('acres')"/>
            </a>
          </th>
          <th scope="col">
            <span class='search-result-header'>Locality</span>
            <a @click="changeSort('localityName')">
              <font-awesome-icon
              :class="getSortClass('localityName')"
              :icon="getSortIcon('localityName')"/>
            </a>
          </th>
          <th scope="col"></th>
        </tr>
      </thead>
</template>
<script>
export default {
  name: 'ProjectSearchResultHeader',
  props: {
    changeSort: {
      type: Function,
    },
    getSortClass: {
      type: Function,
    },
    getSortIcon: {
      type: Function,
    },
  },
};
</script>
